// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {LabelMediumText, LabelSmallText} from '../core/Type';
import {FixedSpace, FlexibleSpace, Separator} from '../core/Spacing';
// Controls
import Button from '../controls/Button';
import TabBar from '../controls/TabBar';
import TextField from '../controls/TextField';
import SelectBox from '../controls/SelectBox';
// Layouts
import ToolBar from '../layouts/ToolBar';
import Pane from '../layouts/Pane';
import Panel from '../layouts/Panel';
import Tree from '../layouts/Tree';
import LabeledControl from '../layouts/LabeledControl';

export default class ContentTreeEditor extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            contentTreeEditor: {
                display: "flex",
                flexDirection: "column-reverse",
                width: "100%",
                height: "100%",
            },
        });
        return (
            <div className={css(styles.contentTreeEditor)}>
                <ContentPane />
                <ToolBar>
                    <Button title="Content" style={Button.Style.Text} variant={Button.Variant.Dropdown} />
                    <FlexibleSpace />
                    <UserDropdown />
                </ToolBar>
            </div>
        );
    }
}

export class ContentPane extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            contentPane: {
                display: "flex",
                flexDirection: "row-reverse",
                width: "100%",
                flexGrow: 1,
            },
        });
        return (
            <div className={css(styles.contentPane)}>
                <ContentTreeEditorDetailPane />
                <ContentTreeEditorSourcePane />
            </div>
        );
    }
}

export class ContentTreeEditorSourcePane extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            sourcePane: {
                flex: 1,
            },
            tree: {
                flexGrow: 1,
            },
        });
        return (
            <Pane styles={[styles.sourcePane]}>
                <ToolBar>
                    <Button title="Show publish queue" style={Button.Style.Text} />
                    <FlexibleSpace />
                    <Button title="Select items to publish" />
                </ToolBar>
                <Tree styles={[styles.tree]} />
                <ToolBar>
                    <Button title="English (United States)" style={Button.Style.Text} variant={Button.Variant.Dropdown} />
                </ToolBar>
            </Pane>
        );
    }
}

export class ContentTreeEditorDetailPane extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            detailPane: {
                flex: 2,
            },
        });
        return (
            <Pane styles={[styles.detailPane]}>
                <ContentTreeItemEditorPane />
                <ToolBar>
                    <Button title="Average velocity and average speed" variant={Button.Variant.Dropdown} style={Button.Style.Text} />
                    <FixedSpace />
                    <Separator />
                    <FixedSpace />
                    <TabBar items={["Editor", "History", "Analytics"]} selectedIndex={0} />
                    <FlexibleSpace />
                    <Button title="Discard changes" style={Button.Style.Text} />
                    <FixedSpace />
                    <Button title="Save changes" />
                </ToolBar>
            </Pane>
        );
    }
}

export class ContentTreeItemEditorPane extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                flexDirection: "row-reverse",
            },
            halfWidth: {
                flex: 1,
            },
            fullHeight: {
                flexGrow: 1,
            },
        });
        return (
            <Pane styles={[styles.container, styles.fullHeight]}>
                <Pane styles={[styles.halfWidth, styles.fullHeight]}>
                    <Panel styles={[styles.fullHeight, styles.fullHeight]}>
                        <Preview />
                    </Panel>
                    <ToolBar size={ToolBar.Size.Small}>
                        <Button title="Phone" variant={Button.Variant.Dropdown} style={Button.Style.Text} />
                    </ToolBar>
                </Pane>
                <Pane styles={[styles.halfWidth, styles.fullHeight]}>
                    <ToolBar size={ToolBar.Size.Small}>
                        <LabelSmallText>Live version</LabelSmallText>
                        <FlexibleSpace />
                        <LabelSmallText>Last changed by you 3 minutes ago</LabelSmallText>
                    </ToolBar>
                    <Panel styles={[styles.fullHeight]}>
                        <Button title="Open exercise editor"/>
                        <FixedSpace variant={FixedSpace.Variant.Vertical} />
                        <LabeledControl title="Title">
                            <TextField placeholder="< 96 characters (suggested)" />
                        </LabeledControl>
                        <FixedSpace variant={FixedSpace.Variant.Vertical} />
                        <LabeledControl title="Description">
                            <TextField placeholder="< 128 characters (suggested)" />
                        </LabeledControl>
                        <FixedSpace variant={FixedSpace.Variant.Vertical} />
                        <LabeledControl title="Visibility">
                            <SelectBox placeholder="Select an option" options={["Private", "Unlisted", "Public"]} />
                        </LabeledControl>
                    </Panel>
                    <ToolBar size={ToolBar.Size.Small}><LabelMediumText>Metadata</LabelMediumText></ToolBar>
                </Pane>
            </Pane>
        );
    }
}

export class Preview extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            screen: {
                width: 320,
                height: 480,
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "auto",
                marginBottom: "auto",
                borderRadius: 1,
                backgroundColor: CoreMetrics.Color.Neutral.White,
            },
        });
        let combinedStyles = [styles.screen, CoreStyles.dropShadow];

        return (
            <div className={css(combinedStyles)}></div>
        );
    }
}

export class UserDropdown extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            userDropdown: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
        });
        const fullName = this.props.fullName;
        const initials = this.props.initials;
        return (
            <div className={css(styles.userDropdown)}>
                <LabelMediumText>{fullName}</LabelMediumText>
                <Avatar initials={initials} />
            </div>
        );
    }
}
UserDropdown.defaultProps = {
    fullName: "Valerie Frizzle",
    initials: "VF",
};

export class Avatar extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            avatar: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: CoreMetrics.IconSize.Large(),
                height: CoreMetrics.IconSize.Large(),
                borderRadius: "50%",
                backgroundColor: CoreMetrics.Color.Debug,
                marginLeft: CoreMetrics.ElementSpacing.XSmall(),
            },
            avatarLabel: {
                color: CoreMetrics.Color.Neutral.White,
            },
        });
        const initials = this.props.initials;
        return (
            <div className={css(styles.avatar)}>
                <LabelSmallText styles={[styles.avatarLabel]}>{initials}</LabelSmallText>
            </div>
        );
    }
}
Avatar.defaultProps = {
    initials: "VF",
};



// WEBPACK FOOTER //
// ./src/demo/ContentTreeEditor.jsx